import { faHandshakeSlash, faHome } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { HOME_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

export const NotAccessiblePhoneScreenPage = React.memo(() => (
  <FlexBox vertical gap sx={{ "mt": "3rem", "& .icon": { color: theme => theme.palette.error.main } }}>
    <FlexBox gap="2rem" sx={{ m: "1rem" }}>
      <FontAwesomeIcon icon={faHandshakeSlash} size="6x" className="icon" />
      <Typography color="error" fontSize="3rem" fontWeight="600" textAlign="center">
        {translate("page.disabled")}
      </Typography>
    </FlexBox>
    <Typography color="error" fontSize="1.2rem" fontWeight="600" textAlign="center">
      {translate("page.phone.disabled")}
    </Typography>
    <Button
      onClick={() => navigate(HOME_PATH)}
      variant="contained"
      startIcon={<FontAwesomeIcon icon={faHome} size="2x" />}
      sx={{ mt: "1vw" }}>
      {translate("page.home")}
    </Button>
  </FlexBox>
))
